<template>
  <a-spin size="large" :spinning="exportLoading">
  <div class="model-design">
		<div class="top-bar" @click="changeEditFalse">
      <div>
        <icon-font type="icon-left" style="margin-right: 12px" @click="goBack"/>
        <span class="main-title" v-if="!isEdit" @click.stop="isEdit = !isEdit">{{mainTitle}}</span>
        <icon-font type="icon-Edit" v-if="!isEdit" class="edit-title" @click.stop="isEdit = !isEdit"/>
        <div style="width: 216px; display: inline-block;" @click.stop >
          <a-input :max-length="50"  style="width: 500px;" v-if="isEdit" v-model="mainTitle" ref="nameInput"/>
        </div>
      </div>
      <el-input-number
        v-model="zoom"
        :step="1"
        :min="50"
        :max="300"
        size="small"
        class="zoom-input"
      />
      <div>
        <a-button class="ml-8" @click="batchFlagChange"> {{batchFlag?'取消':''}}批量操作</a-button>
        <!-- <a-button @click="exportDashboard()" class="btn-tertiary"> 
          <icon-font class="title-icon" type="icon-Export"  />
            导出
        </a-button> -->
        <a-button class="ml-8 btn-tertiary" @click="handlePreview()">
          <icon-font class="title-icon" type="icon-Eye-Open"  />
            预览
        </a-button>
        <a-button type="primary" :loading="saveLoading" class="ml-8" @click="saveData()"> 保存</a-button>
      </div>
		</div>
    <div>
      <screenDesigner ref="refScreenDesigner" :zoom="zoom" @nameChange="(name) => this.mainTitle = name" :name="mainTitle"  @saveLoading="(flag) => saveLoading = flag" @nameVisible="nameOpen" :batchFlag="batchFlag"/>
    </div>
    <a-modal v-model="nameVisible" :maskClosable="false" title="请输入模型名称" :ok-text="type === 'save'?'保存':'预览'" cancel-text="取消" @ok="nameOk" :bodyStyle="{
      padding: '0px 24px'
    }">
      <a-input v-model="name" placeholder="请输入模型名称"></a-input>
    </a-modal>
	</div>
  </a-spin>
</template>
<script>
import screenDesigner from '@/views/bigscreenDesigner/designer/index.vue'
// import UserInfo from "./userInfo";
// import ModifyPassword from "./modifyPassword";

export default {
  name: "modelDesign",
  components: {
    screenDesigner
  },
  data() {
    return {
      isEdit: false,
      mainTitle: 'self chart',
      exportLoading: false,
      saveLoading: false,
      // 模型名称弹框
      nameVisible: false,
      type: 'save',
      name: '',
      zoom: 100,
      batchFlag: false
    };
  },
  methods: {
    batchFlagChange() {
      this.batchFlag = !this.batchFlag
      if(this.batchFlag) {
        this.$refs.refScreenDesigner?.handleMouseDown()
        this.$refs.refScreenDesigner?.setOptionsOnClickScreen()
      }
    },
    nameOpen(flag) {
      this.type = flag
      this.name = ''
      this.nameVisible = true
    },
    nameOk() {
      if(!this.name) {
        this.$message.error('请输入模型名称')
        return
      }
      this.mainTitle = this.name
      this.nameVisible = false
      this.$nextTick(() => {
        this.type === 'save'?this.saveData():this.handlePreview()
      })
    },
    goBack() {
      this.$refs.refScreenDesigner.goBackHandle();
    },
    changeEditFalse() {
      this.isEdit = false;
    },
    exportDashboard(num){
      this.$refs.refScreenDesigner.exportDashboard();
    },
    handlePreview(){
      this.$refs.refScreenDesigner.viewScreen();
    },
    saveData(){
      this.$refs.refScreenDesigner.saveData();
    },
  },
  async mounted() {
    const name = this.$route.query.name;
    this.mainTitle = name || ''
    if(!this.mainTitle) {
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
      })
    }
    window.addEventListener('click', () => {
      this.isEdit = false
    })
  }
};
</script>
<style scoped lang="less">
.model-design {
	height: 100%;
	width: 100%;
	background: #fff;
	position: relative;
  padding-right: 24px;
  overflow-y: hidden;
  // padding-bottom: 26px;
  box-sizing: border-box;
	.top-bar {
		padding-top: 32px;
    padding-bottom: 22px;
		padding-left: 24px;
    display: flex;
    justify-content: space-between;
		.anticon {
			font-size: 16px;
          line-height: 26px;
          color: #677392;
			vertical-align: middle;
			cursor: pointer;
		}
	}
  .edit-title{
    font-size: 16px;
    padding-left: 8px;
    line-height: 26px;
    color: #9CA9CB;
  }
  .title-icon{
    line-height: 1 !important;
  }
  .zoom-input {
    position: absolute;
    margin-left: -139px;
    left: 50%;
    /deep/ .el-input {
      position: relative;
      &::before {
        // 也可以将此处的分钟换成其他单位
        content: "%";
        position: absolute;
        top: 0;
        right: 42px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
      }
    }
  }
}
</style>